import { render, staticRenderFns } from "./UploadVideoComponent.vue?vue&type=template&id=072ba965&"
import script from "./UploadVideoComponent.vue?vue&type=script&lang=ts&"
export * from "./UploadVideoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src367672788/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072ba965')) {
      api.createRecord('072ba965', component.options)
    } else {
      api.reload('072ba965', component.options)
    }
    module.hot.accept("./UploadVideoComponent.vue?vue&type=template&id=072ba965&", function () {
      api.rerender('072ba965', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/UploadVideoComponent.vue"
export default component.exports